import { render } from "./profile.page.analytics.vue?vue&type=template&id=294168e4"
import script from "./profile.page.analytics.vue?vue&type=script&lang=js"
export * from "./profile.page.analytics.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__